// Global Cart & Mobile Menu Open/Close functions accessible anywhere
window.openChaskaCart = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const drawers = document.querySelectorAll('#cartDrawer, .cart-drawer, cart-drawer, .drawer');
  drawers.forEach(d => {
    d.classList.add('open', 'active');
    d.setAttribute('aria-hidden', 'false');
    d.setAttribute('open', '');
  });
  document.body.classList.add('locked', 'overflow-hidden');
  if (typeof window.fetchChaskaCart === 'function') window.fetchChaskaCart();
};

window.closeChaskaCart = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const drawers = document.querySelectorAll('#cartDrawer, .cart-drawer, cart-drawer, .drawer');
  drawers.forEach(d => {
    d.classList.remove('open', 'active', 'is-active', 'animate');
    d.setAttribute('aria-hidden', 'true');
    d.removeAttribute('open');
  });
  document.body.classList.remove('locked', 'overflow-hidden');
};

window.openMobileMenu = function(e) {
  if (e && e.preventDefault) e.preventDefault();
  const menus = document.querySelectorAll('#mobileMenu, .mobile-menu');
  menus.forEach(m => {
    m.classList.add('open', 'active');
    m.setAttribute('aria-hidden', 'false');
  });
  document.body.classList.add('locked', 'overflow-hidden');
};

window.closeMobileMenu = function(e) {
  if (e && e.target && e.target.tagName !== 'A' && e.preventDefault) {
    e.preventDefault();
  }
  const menus = document.querySelectorAll('#mobileMenu, .mobile-menu');
  menus.forEach(m => {
    m.classList.remove('open', 'active');
    m.setAttribute('aria-hidden', 'true');
  });
  document.body.classList.remove('locked', 'overflow-hidden');
};

document.addEventListener('DOMContentLoaded', () => {
  // Select DOM Elements
  const cartDrawer = document.getElementById('cartDrawer');
  const mobileMenu = document.getElementById('mobileMenu');
  const menuLinks = document.querySelectorAll('.js-menu-link, .mobile-links a');
  
  const cartCount = document.getElementById('cartCount');
  const cartItemsContainer = document.getElementById('cartItemsContainer');
  const cartSubtotal = document.getElementById('cartSubtotal');
  const cartFooter = document.getElementById('cartFooter');
  
  const shippingProgressText = document.getElementById('shippingProgressText');
  const shippingProgressBar = document.getElementById('shippingProgressBar');
  const cartToast = document.getElementById('cartToast');
  const mobileSticky = document.getElementById('mobileSticky');

  // Document-level Global Click Event Delegation for Cart & Menu Open/Close
  document.addEventListener('click', (e) => {
    // Open Cart Triggers
    if (e.target.closest('#cartOpen') || e.target.closest('.cart-count')) {
      e.preventDefault();
      window.openChaskaCart(e);
      return;
    }

    // Close Cart Triggers
    if (e.target.closest('#cartClose') || e.target.closest('[data-close-cart]') || e.target.closest('.cart-backdrop') || e.target.closest('.cart-drawer__overlay')) {
      e.preventDefault();
      window.closeChaskaCart(e);
      return;
    }

    // Open Mobile Menu Trigger
    if (e.target.closest('#menuOpen')) {
      e.preventDefault();
      window.openMobileMenu(e);
      return;
    }

    // Close Mobile Menu Trigger (Backdrop & Cross button only)
    if (e.target.closest('#menuClose') || e.target.closest('#menuCloseBackdrop') || e.target.closest('.mobile-menu-backdrop')) {
      e.preventDefault();
      window.closeMobileMenu(e);
      return;
    }

    // Mobile Navigation Link Click: Close drawer & allow natural page navigation
    const menuLink = e.target.closest('.js-menu-link, .mobile-links a');
    if (menuLink) {
      window.closeMobileMenu();
    }
  });
  menuLinks.forEach(link => link.addEventListener('click', window.closeMobileMenu));

  // --- Toast Notifications ---
  function showToast(text, emoji = '😋') {
    if (!cartToast) return;
    cartToast.innerHTML = `${text} ${emoji}`;
    cartToast.classList.add('show');
    setTimeout(() => {
      cartToast.classList.remove('show');
    }, 2500);
  }

  // --- Shopify AJAX Cart Functions ---
  
  // Format Currency (Shopify uses paise/cents - divide by 100)
  function formatPrice(cents) {
    const rupees = Math.round(cents / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  // Fetch Cart Details from Shopify API
  function fetchCart() {
    const cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url + '.js' : '/cart.js';
    fetch(cartUrl)
      .then(res => res.json())
      .then(cart => {
        updateCartUI(cart);
      })
      .catch(err => console.error('Error fetching cart:', err));
  }
  window.fetchChaskaCart = fetchCart;

  // Update Cart Drawer UI Elements
  function updateCartUI(cart) {
    // Update Header Bubble Count
    if (cartCount) cartCount.textContent = cart.item_count;

    // Toggle Empty State / Footer
    if (cart.item_count === 0) {
      if (cartItemsContainer) {
        cartItemsContainer.innerHTML = `
          <div class="empty">
            <div class="ic">🛒</div>
            <h3>Cart abhi khaali hai</h3>
            <p>Trial box se shuru karo—sab 12 flavours ek saath.</p>
          </div>
        `;
      }
      if (cartFooter) cartFooter.style.display = 'none';
    } else {
      if (cartFooter) cartFooter.style.display = 'block';
      if (cartSubtotal) cartSubtotal.textContent = formatPrice(cart.total_price);
      
      // Populate Item List
      let itemsHtml = '';
      cart.items.forEach((item, index) => {
        const itemEmoji = (item.properties && item.properties.emoji) ? item.properties.emoji : '😋';
        const itemColor = (item.properties && item.properties.color) ? item.properties.color : '#F7B32B';
        const lineIndex = index + 1;
        
        itemsHtml += `
          <article class="cart-item" data-id="${item.id}" data-key="${item.key || item.id}">
            <div class="cart-thumb" style="--thumb: ${itemColor};">
              ${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : itemEmoji}
            </div>
            <div>
              <h3>${item.product_title}</h3>
              <small>${formatPrice(item.final_price)} each</small>
              <div class="qty">
                <button type="button" class="qty-btn minus" data-key="${item.key || item.id}" data-line="${lineIndex}" data-qty="${item.quantity - 1}">−</button>
                <span>${item.quantity}</span>
                <button type="button" class="qty-btn plus" data-key="${item.key || item.id}" data-line="${lineIndex}" data-qty="${item.quantity + 1}">+</button>
              </div>
              <button type="button" class="remove" data-key="${item.key || item.id}" data-line="${lineIndex}">Remove</button>
            </div>
            <div class="cart-item-price">
              ${formatPrice(item.final_line_price)}
            </div>
          </article>
        `;
      });
      if (cartItemsContainer) cartItemsContainer.innerHTML = itemsHtml;
    }

    // Update Free Shipping Progress Bar
    const shippingProgContainer = document.querySelector('.shipping-progress');
    const thresholdRupees = shippingProgContainer ? parseInt(shippingProgContainer.dataset.threshold || '499', 10) : 499;
    const threshold = thresholdRupees * 100; // in paise
    const totalPrice = cart.total_price;
    if (totalPrice >= threshold) {
      if (shippingProgressText) shippingProgressText.innerHTML = '🎉 <b>Free shipping unlocked!</b>';
      if (shippingProgressBar) shippingProgressBar.style.width = '100%';
    } else {
      const needed = threshold - totalPrice;
      if (shippingProgressText) shippingProgressText.innerHTML = `Add <b>${formatPrice(needed)}</b> more for FREE shipping`;
      const percentage = Math.min((totalPrice / threshold) * 100, 100);
      if (shippingProgressBar) shippingProgressBar.style.width = percentage + '%';
    }
  }

  // Add Item to Shopify Cart via AJAX
  function addItemToCart(variantId, quantity = 1, properties = {}, name = '') {
    const cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url + '.js' : '/cart/add.js';
    
    // Filter out internal UI properties (emoji, color) so Shopify merges identical variant items
    const cleanProperties = {};
    if (properties && typeof properties === 'object') {
      for (const [key, value] of Object.entries(properties)) {
        if (key !== 'emoji' && key !== 'color') {
          cleanProperties[key] = value;
        }
      }
    }

    const formData = {
      id: variantId,
      quantity: quantity
    };

    if (Object.keys(cleanProperties).length > 0) {
      formData.properties = cleanProperties;
    }

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    })
      .then(res => {
        if (!res.ok) {
          return res.json().then(errData => {
            throw new Error(errData.description || errData.message || 'Could not add item');
          });
        }
        return res.json();
      })
      .then(item => {
        showToast((name || item.title || 'Product') + ' cart mein add hua', properties.emoji || '😋');
        window.openChaskaCart();
      })
      .catch(err => {
        console.error('Error adding item:', err);
        showToast(err.message || 'Could not add item', '❌');
      });
  }

  // Update Item Quantity in Cart via AJAX
  function updateCartItem(variantKey, quantity, lineIndex) {
    const cartChangeUrl = (window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url + '.js' : '/cart/change.js';
    
    // Always include line index (1-based integer) which is required for items with custom properties
    const formData = {
      line: lineIndex || 1,
      quantity: quantity
    };

    // If variantKey is a true line item key (contains a colon ':')
    if (variantKey && typeof variantKey === 'string' && variantKey.includes(':')) {
      formData.id = variantKey;
    }

    fetch(cartChangeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(formData)
    })
      .then(res => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res.json();
      })
      .then(cart => {
        if (cart.errors || cart.status) {
          console.error('Shopify API Error:', cart.errors || cart.description);
          showToast(cart.errors || cart.description || 'Could not update quantity', '❌');
          return;
        }
        updateCartUI(cart);
      })
      .catch(err => {
        console.error('Error updating quantity:', err);
        showToast('Could not update quantity', '❌');
      });
  }

  // --- Event Listeners for Cart Interactions ---
  
  // Intercept any click on add to cart or checkout buttons
  document.body.addEventListener('click', (e) => {
    // Checkout Button Handler
    const checkoutBtn = e.target.closest('button[name="checkout"], .js-checkout, .js-checkout-btn');
    if (checkoutBtn) {
      e.preventDefault();
      e.stopPropagation();
      const cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      const checkoutUrl = cartUrl.replace(/\/cart$/, '') + '/checkout';
      window.location.href = checkoutUrl;
      return;
    }

    // Buy Now Button Handler (.js-buy-now or .btn-marigold)
    const buyNowBtn = e.target.closest('.js-buy-now, .btn-marigold');
    if (buyNowBtn) {
      e.preventDefault();
      e.stopPropagation();
      
      const form = buyNowBtn.closest('form');
      const selectedVarId = buyNowBtn.getAttribute('data-id') || (form && form.querySelector('input[name="id"]')?.value) || document.getElementById('selectedVariantId')?.value;
      const qtyVal = (form && form.querySelector('input[name="quantity"]')?.value) || document.getElementById('quantityInput')?.value || 1;
      const variantId = parseInt(selectedVarId, 10);
      const requestedQty = Math.max(1, parseInt(qtyVal, 10));

      const cartAddUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url + '.js' : '/cart/add.js';
      const cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      const checkoutUrl = cartUrl.replace(/\/cart$/, '') + '/checkout';

      if (variantId && !isNaN(variantId) && variantId > 0) {
        fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: variantId, quantity: requestedQty })
        })
          .then(() => { window.location.href = checkoutUrl; })
          .catch(() => { window.location.href = checkoutUrl; });
      } else {
        window.location.href = checkoutUrl;
      }
      return;
    }

    // Add to Cart Button Handler (.js-add)
    const addBtn = e.target.closest('.js-add');
    if (addBtn) {
      e.preventDefault();
      
      const variantId = addBtn.getAttribute('data-id');
      const name = addBtn.getAttribute('data-name') || 'Item';
      const emoji = addBtn.getAttribute('data-emoji') || '😋';
      const color = addBtn.getAttribute('data-color') || '#F7B32B';
      
      // Dynamically detect selected quantity (e.g. from hidden input or span on product page)
      const form = addBtn.closest('form');
      const buyRow = addBtn.closest('.buy-row');
      const qtyInput = (buyRow && buyRow.querySelector('input[name="quantity"]')) || 
                       (form && form.querySelector('input[name="quantity"]')) || 
                       document.getElementById('quantityInput');
      const quantity = (qtyInput && qtyInput.value && !isNaN(qtyInput.value)) ? Math.max(1, parseInt(qtyInput.value, 10)) : 1;
      
      // If valid numeric Shopify variant ID exists
      if (variantId && !isNaN(variantId) && Number(variantId) > 0) {
        addItemToCart(Number(variantId), quantity, { emoji, color }, name);
      } else {
        // Fallback for demo buttons or missing variant ID
        showToast(name + ' cart mein add hua', emoji);
        window.openChaskaCart();
      }
    }
  });

  // Delegation inside Cart Drawer (Quantity changes and remove)
  if (cartItemsContainer) {
    cartItemsContainer.addEventListener('click', (e) => {
      // Plus / Minus Quantity Buttons
      const qtyBtn = e.target.closest('.qty-btn');
      if (qtyBtn) {
        e.preventDefault();
        e.stopPropagation();
        const key = qtyBtn.getAttribute('data-key');
        const line = parseInt(qtyBtn.getAttribute('data-line'), 10);
        const qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
        updateCartItem(key, qty, line);
        return;
      }
      
      // Remove Button
      const removeBtn = e.target.closest('.remove');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        const key = removeBtn.getAttribute('data-key');
        const line = parseInt(removeBtn.getAttribute('data-line'), 10);
        updateCartItem(key, 0, line);
        return;
      }
    });
  }

  // Hide/Show Mobile Sticky Bar based on scroll position (Excluding product pages)
  window.addEventListener('scroll', () => {
    if (!mobileSticky) return;
    if (document.body.classList.contains('template-product') || window.location.pathname.includes('/products/')) {
      mobileSticky.style.display = 'none';
      return;
    }
    if (window.scrollY > 400) {
      mobileSticky.style.display = 'flex';
    } else {
      mobileSticky.style.display = 'none';
    }
  });

  // Keyboard accessibility (Escape key closes cart)
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      window.closeChaskaCart();
      if (typeof window.closeMobileMenu === 'function') window.closeMobileMenu();
    }
  });

  // Initial Cart Count Check
  fetchCart();
});
